<template>
  <div class="demo">
    <div class="hero">
      <div class="container">
        <h3>Blogpost</h3>
        <h1>Anders denken, Anders doen!</h1>
        <p>
          Geregeld wordt aan mij gevraagd wat eigenlijk het verschil is tussen
          het plannen met een digitaal planbord en plannen met Roosterplatform.
          Als ik deze vraag krijg, dan denk ik meestal: “heb je even?” De
          verschillen zijn namelijk veel en groot!
        </p>
        <div class="image">
          <img
            src="../assets/img/blog-images/anders-denken.png"
            alt=""
          >
        </div>
      </div>
    </div>

    <div class="section grey-light extra-padding-bottom">
      <div class="container">
        <div class="section-title">
          <h3>Goed plannen = optimaal afstemmen</h3>
        </div>
        <p>
          Om elkaar goed te begrijpen is het handig om allereerst te vertellen
          wat wij bedoelen met plannen. Roosterplatform beschouwt plannen als
          hét middel om vraag en aanbod op optimale wijze op elkaar af te
          stemmen. Dat wil zeggen dat wij vinden dat goed plannen gaat over het
          optimaal afstemmen van de beschikbaarheid van de behandelaar, het
          middel en de ruimte (het aanbod) op de vraag van de cliënt (het
          behandelprogramma). Zodat de juiste medewerkers, op het juiste moment,
          op de juiste plek met het juiste middel professionele zorg kunnen
          bieden aan de cliënt.
        </p>

        <div class="section-title">
          <h3>
            Goed plannen = integraal perspectief cliënt + behandelaar + planner
            + arts + organisatie
          </h3>
        </div>
        <p>
          Deze optimale afstemming van aanbod op vraag heeft nadrukkelijk niet
          alleen betrekking op efficiëntie. Natuurlijk gaat goed plannen over
          het transparant maken van de capaciteit en het proactief inzicht geven
          in de (niet) passende bezetting. Om eerlijk te zijn vinden wij dit pas
          het begin van plannen. Wij vinden het noodzakelijk om de volle breedte
          en complexiteit van planningsvraagstukken mee te nemen in de planning.
          Deze planningsvraagstukken worden door ons integraal benaderd. Plannen
          gaat wat betreft Roosterplatform dus nadrukkelijk naast het efficiënt
          inzetten van de medewerkers, ook over het plezierig en zorgvuldig
          plannen van de behandelingen en agenda’s. Om deze kwaliteit van de
          planning te garanderen zijn de wensen en eisen van cliënten,
          behandelaren, artsen én organisatie medebepalend voor de planning.
          Plannen is dus een middel om kwantitatief én kwalitatief aanbod en
          vraag optimaal te matchen.
        </p>

        <div class="section-title">
          <h3>Echt goed plannen is met een digitaal planbord onmogelijk</h3>
        </div>
        <p>
          Een planner die plant met behulp van een digitaal planbord moet met
          beperkte inzichten zorgdragen voor een optimale planning. Bij het
          plannen met een planbord is de planner eigenlijk de hele dag bezig een
          te moeilijke sudoku te leggen. Elke afspraak wordt door de planner op
          het planbord gepland. En elke wijziging in het behandelprogramma van
          een cliënt, moet één voor één worden afgehandeld. Bovendien betekent
          elke wijziging in de beschikbaarheid veel puzzelen, herplannen en
          laten vervallen van afspraken. Een planner met een planbord is
          daardoor een groot deel van de dag bezig met het verschuiven en
          herplannen van afspraken. Tijdens het plannen rekening houden met alle
          kwaliteitsaspecten is voor een planner vaak onmogelijk, doordat een
          planner geen overzicht heeft over en inzicht heeft in alles wat te
          maken heeft met de planning.
        </p>
        <div class="section-title">
          <h3>Goed plannen kan alleen geautomatiseerd</h3>
        </div>
        <p>
          Roosterplatform heeft het denken over de planning daarom omgedraaid.
          De computer neemt het puzzelwerk over. Om dat goed te kunnen, zijn
          alle wensen en eisen geborgd in de software. Behandelaren en artsen
          hebben daarmee veel invloed op hetgeen er gepland moet worden en hoe
          ze dat gepland willen hebben. De software legt vervolgens de hele
          puzzel. De functie van de planner schuift daardoor op van planner naar
          capaciteitscoördinator.
        </p>
        <p>
          Doordat Roosterplatform geautomatiseerd de hele planpuzzel legt, op
          basis van de vooraf geformuleerde eisen, worden de behandelingen beter
          gepland, de agenda’s plezieriger en de organisatie doelmatiger.
        </p>
        <p>
          Ik kan hier uren over praten, dus mocht je meer willen weten, neem
          vooral contact met me op.
        </p>

        <span>Door: </span>
        <b>Herman de Jager - CEO Roosterplatform</b>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Article9",

  mounted() {},
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Anders denken, Anders doen",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";
.hero {
  padding: 100px 0;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
  position: relative;
  z-index: 1;
}
.zoho-form {
  background: $grey-light;
  border-radius: $border-radius;
}
img {
  border-radius: $border-radius;
}
p + .section-title {
  margin-top: 50px;
}
@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;
  }
}
</style>
